import { z } from 'zod';
import { dateValidation } from '../../../../validation';

export const EndOfCareProfessionalSeenSchema = z.object({
  service: z.object(
    {
      id: z.string().min(1),
      name: z.string().optional(),
      professionalType: z.string().optional(),
    },
    'Support type is required',
  ),
  appointments: z.array(
    z.object({
      id: z.string().min(1),
      date: dateValidation().optional(),
      professionalName: z.string().optional(),
    }),
  ),
});

export type EndOfCareProfessionalSeen = z.infer<
  typeof EndOfCareProfessionalSeenSchema
>;
